module.exports = "<div class=\"modal-header\" id=\"report-modal-header\">\n  <h2>Downloading Report</h2>\n  <button class=\"btn btn-link\" ng-click=\"close()\"><i class=\"fa fa-close\"></i></button>\n</div>\n<div class=\"modal-body\" id=\"report-modal-body\">\n  <loading></loading>\n  <p>When finished downloading, this report will also be added to your <a ui-sref=\"app.admin.attachments({id: profile_uid})\" ng-click=\"close()\">File Manager</a> if you choose to exit this page.</p>\n</div>\n\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/modals/reports/template.html
// module id = 1358
// module chunks = 0